(function($){
    $(document).ready(function(){
        if($(window).width() > 767) {
            $('[name="vin"]').on('input', function (event) {
                var value = $(this).val();
                $(this).val(value.replace(/\s/g, '').toUpperCase());
            });
        }
        $('.order-form').find('input[type="text"], input[type="date"], select').each(function(){
            $('<img class="input-loader" src="'+$('.loader').find('img').attr('src')+'" />').appendTo($(this).closest('.input-stdv').find('label'));
        })
        $('[name="vehicle-plate"]').inputmask('AAA-9999', {
            'placeholder': ' '
        });
        $('[name="client-postcode"]').inputmask('999 99', {
            'placeholder': ' '
        });
        $('[name="power"]').inputmask({
            alias: 'numeric',
            max: 999,
            rightAlign: false, // Wyłączenie prawojustyfikacji
            placeholder: ''
        });
        $('[name="vin"]').inputmask('*****************', {
            'placeholder': ' ',
            'definitions': {
                '*': {
                    validator: "[^o\s]",
                    cardinality: 1,
                    casing: 'upper'
                }
            }
        });
        $('[name="client-phone"]').inputmask("+30 9999999999", {
            onBeforeMask: function (value, opts) {
                // Jeśli input jest pusty, wstaw "+30 " jako prefiks
                if (value.length === 0) {
                    return "+30 ";
                }
                // Jeśli input zaczyna się od "+30 ", pozostaw to jako prefiks
                if (value.startsWith("+30 ")) {
                    return value;
                }
                // W przeciwnym razie, dodaj "+30 " na początku wartości
                return "+30 " + value;
            },
            onKeyDown: function(event, buffer, caretPos, opts){
                // Zablokuj usunięcie "+30 " z początku inputa
                if (event.keyCode === 8 && caretPos.begin <= 4) {
                    event.preventDefault();
                }
            }
        });
        $('[name="make_year"]').inputmask({
            alias: 'numeric',
            max: 9999,
            rightAlign: false, // Wyłączenie prawojustyfikacji
            placeholder: ''
        });
        $('[name="client-nip"]').inputmask({
            inputmode: 'numeric',
            digits: 0,
            numericInput: true,
            rightAlign: false, // Wyłączenie prawojustyfikacji
            placeholder: '',
            allowLeadingZeroes: true
        });
        $('[name="vehicle-value"], [name="oc-insurance-amount"]').inputmask({
            alias: 'numeric',
            suffix: '€', // Dodanie znaku euro na końcu
            numericInput: true, // Pozwala na wprowadzanie tylko liczb
            autoUnmask: true, // Wyświetla wartość bez maski
            groupSeparator: '', // Wyłączenie separatora tysięcy
            digits: 0, // Określenie ilości cyfr po przecinku
            rightAlign: false, // Wyłączenie prawojustyfikacji
            max: 999999 // Maksymalna wartość
        });
    })
    $('.calculate-insurance').on('submit', function(e){
        e.preventDefault();
        if(!$(this).hasClass('locked')) {
            $(this).addClass('locked');
            calculator_gb();
        }
    });
    $('.order-form input[type="text"], .order-form input[type="date"]').on('change', function(){
        wagas_validate_single_field($(this).attr('name'), $(this).val());
        insert_order_summary();
    })
    $('.insurance-questions').on('submit', function(e){
        e.preventDefault();
        validate_wagas_inquiry();
    })
    $('.insurance-questions input[type="radio"]').on('change', function(){
        if($(this).attr('data-lock') == 1){
            $(this).closest('.question-container').addClass('invalid');
        }
        else{
            $(this).closest('.question-container').removeClass('invalid');
        }
        if($('.question-container.invalid').length > 0){
            $('.insurance-questions').addClass('invalid');
        }
        else{
            $('.insurance-questions').removeClass('invalid');
        }
    })
    $('body').on('click', '.order-form-view-mode .change-data a', function(e){
        e.preventDefault();
        $('.order-form').slideDown(500);
        $('.order-form-view-mode').slideUp(500);
        $('.step4-title').slideUp(500);
    });
    $('body').on('click', '.order-form-view-mode .change-plan a', function(e){
        e.preventDefault();
        $('.calculate-insurance').submit();
        $('.order-form').slideUp(500);
        $('.order-form-view-mode').slideUp(500);
        $('.step4-title').slideUp(500);
        $('.calc-content').slideDown(500);
        $('.calc-content').addClass('soft-refresh');
    });
    $('[name="client-type"]').on('change', function(){
        $('.change-by-client-type').slideUp(500);
        $('.change-by-client-type input').val('');
        $('.order-form [name="client-type"]').each(function(){
            if($(this).prop('checked') == true){
                $('.change-by-client-type.client-' + $(this).val()).slideDown(500);
            }
        })
    })

    $('.order-form input, .order-form select').on('click change keyup', function(){
        $(this).closest('.input-stdv').find('.error').remove();
    })

    $(document).ready(function (){
        if($('.order-form').length > 0) {
            form_order_clone();
        }
        if($('.calculate-insurance').length > 0){
            if($('.calculate-insurance [name="register-date"]').val() != ''){
                insert_order_summary();
            }
        }
    })

    // $('[name="vehicle-value"]').on('change', function(){
    //     $('#vehicle-value').val($(this).val());
    //     $('.calculate-insurance [name="vehicle-value"]').val($(this).val());
    //     insert_order_summary();
    // })
    // $('[name="oc-insurance-amount"]').on('change', function(){
    //     $('#oc-value').val($(this).val());
    //     $('.calculate-insurance [name="oc-insurance-amount"]').val($(this).val());
    //     insert_order_summary();
    // })
    // $('[name="oc-insurance-date"]').on('change', function(){
    //     $('#oc-date').val($(this).val());
    //     $('.calculate-insurance [name="oc-date"]').val($(this).val());
    //     insert_order_summary();
    // })

    $('.check-all-agreements input').on('change', function(){
        $('.single-agreement input').prop('checked', $(this).prop('checked'));
    });
    $('.single-agreement input').on('change', function(){
        $(this).prop('checked', $(this).prop('checked'));
    });

    function form_order_clone(){
        $('.order-form-view-mode').html('');
        var vf = $('.order-form').clone();
        $('.order-form-view-mode').append(vf.html());
        $('.order-form-view-mode .submit button').html($('.order-form-view-mode').attr('data-send-button'));
        $('.order-form select, .order-form input:not([type="checkbox"]):not([type="radio"])').on('change', function(){
            $('.order-form-view-mode [name="'+$(this).attr('name')+'"]').val($(this).val());
        })
        $('.order-form input[type="checkbox"], .order-form input[type="radio"]').on('change', function(){
            $('.order-form-view-mode [name="'+$(this).attr('name')+'"]').prop('checked', $(this).prop('checked'));
        })
    }

    $('body').on('click', '.calc-content.soft-refresh .gap-block a', function(e){
        e.preventDefault();
        $('#period').val($(this).closest('.gap-block').attr('data-period')).trigger('change');
        $('#register-date').val($('.calculate-insurance [name="register-date"]').val()).trigger('change');
        $('#vehicle-value').val($('.calculate-insurance [name="vehicle-value"]').val()).trigger('change');
        insert_order_summary();
        $('.calc-content').slideUp(500);
        $('.inquiry').slideDown(500);
    });

    $('#period').on('change', function(){
        $('.order-summary .period-value').html($('#period').val());
    })
    $('#insurance').on('change', function(){
        $('.order-summary .insurance-total .value').html($('#insurance').val());
    })
    $('#price').on('change', function(){
        $('.order-summary .cart-total .value').html($('#price').val());
    })
    $('#date-from').on('change', function(){
        $('.order-summary .date-from').html($('#date-from').val());
    })
    $('#date-to').on('change', function(){
        $('.order-summary .date-to').html($('#date-to').val());
    })

    $('.calc-content .calculate-insurance [name="register-date"], .calc-content .calculate-insurance [name="vehicle-value"]').on('change', function(){
        $('.after-calculate .content .gap-block').remove();
        $('.after-calculate').removeClass('active');
        $('.after-calculate-error').removeClass('active');
    })

    $('.order-form form').on('submit', function(e){
        e.preventDefault();
        validate_wagas_form();
    });
    $('body').on('submit', '.order-form-view-mode form', function(e){
        e.preventDefault();
        create_insurance_request();
    })
    $('.order-form [name="brand"]').on('change', function(){
        $('.order-form [name="model"] option').remove();
        $('.order-form-view-mode [name="model"] option').remove();
        $('.order-form [name="model"]').append('<option value="-1">'+$('.order-form [name="model"]').attr('data-default')+'</option>');
        $('.order-form-view-mode [name="model"]').append('<option value="-1">'+$('.order-form [name="model"]').attr('data-default')+'</option>');
        var group = $(this).val();
        console.log(group);
        $('[name="model-base"]').find('option').each(function(){
            if($(this).attr('data-group') == group){
                $('.order-form [name="model"]').append('<option value="'+$(this).val()+'">'+$(this).val()+'</option>');
                $('.order-form-view-mode [name="model"]').append('<option value="'+$(this).val()+'">'+$(this).val()+'</option>');
            }
        })
        // $('.order-form [name="model"] option').hide();
        // $('.order-form [name="model"] option[data-group="'+$(this).val()+'"]').show();
    })
})(jQuery)


function insert_order_summary(){
    var int, current_price = $('#price').val();
    $.ajax({
        url: ajax_obj.ajaxurl,
        method: 'post',
        data: {
            'action': 'insert_order_summary',
            'calculate_vehicle_value': $('.calculate-insurance [name="vehicle-value"]').val(),
            'calculate_register_date': $('.calculate-insurance [name="register-date"]').val(),
            'of_vehicle_value': $('.order-form [name="vehicle-value"]').val(),
            'of_register_date': $('.order-form [name="register-date"]').val(),
            'of_invoice_date': $('.order-form [name="invoice-date"]').val(),
            'of_insurance_date': $('.order-form [name="oc-insurance-date"]').val(),
            'of_insurance_value': $('.order-form [name="oc-insurance-amount"]').val(),
            'period': $('#period').val(),
            'nonce': ajax_obj.nonce
        },
        beforeSend: function(){
          $('.order-summary').addClass('loading');
            $('.order-form .general-error').html('');
        },
        success: function (data) {
            console.log(data);
            var result = $.parseJSON(data);
            if(!result['price']){
                $('.order-summary:not(.with-change-plan)').slideUp(500);
            }
            else{
                $('.order-summary:not(.with-change-plan)').slideDown(500);
            }
            $('.order-summary').removeClass('loading');
            $('#price').val(result['price']).trigger('change');
            $('#period').val(result['period']).trigger('change');
            $('#register-date').val($('.calculate-insurance [name="register-date"]').val()).trigger('change');
            $('#insurance').val(result['insurance']).trigger('change');
            $('#date-from').val(result['date-from']).trigger('change');
            $('#date-to').val(result['date-to']).trigger('change');
            $('#vehicle-value').val(result['value']).trigger('change');
            $('#owu-value').val(result['value']).trigger('change');
            $('#oc-value').val(result['ocvalue']).trigger('change');
            $('#oc-date').val(result['ocdate']).trigger('change');
            if(result['error']){
                $('.general-error').html(result['error']);
                $('.order-form [name="oc-insurance-date"], .order-form [name="invoice-date"]').closest('.input-stdv').append('<span class="error">'+result['error']+'</span>');
            }
            if(current_price != '' && current_price != result['price']){
                $('.change-price-info').addClass('open');
            }
            else{
                $('.change-price-info').removeClass('open');
            }

        },
        error: function (errorThrown) {
            console.log(errorThrown);
        }
    });
}

function create_insurance_request(){
    var int;
    // console.log($('#insurance-details').serialize());
    $.ajax({
        url: ajax_obj.ajaxurl,
        method: 'post',
        data: {
            'action': 'create_insurance_request',
            'data': $('.order-form form').serialize(),
            'insurance-details': $('#insurance-details').serialize(),
            'nonce': ajax_obj.nonce
        },
        beforeSend: function (errorThrown) {
            $('.order-form-view-mode .loader').css('display', 'flex');
            var i = ' *';
            int = setInterval(function(){
                $('.order-form-view-mode .submit button').html(i);
                i = i + ' *';
            }, 1000)
        },
        success: function (data) {
            clearInterval(int);
            $('.order-form-view-mode .loader').fadeOut(500);
            $('.order-form-view-mode .submit button').html($('.order-form-view-mode').attr('data-send-button'));
            window.location.href = data;
        },
        error: function (errorThrown) {
            console.log(errorThrown);
        }
    });
}
function validate_wagas_form(){
    var int;
    $.ajax({
        url: ajax_obj.ajaxurl,
        method: 'post',
        data: {
            'action': 'validate_wagas_form',
            'data': $('.order-form form').serialize(),
            'nonce': ajax_obj.nonce
        },
        beforeSend: function (errorThrown) {
            $('.order-form .input-stdv .error').remove();
            $('.order-form .general-error').html('');
            $('.order-form-view-mode .general-error').html('');
            $('.order-form .loader').css('display', 'flex');
            var i = ' *';
            int = setInterval(function(){
                $('.order-form .submit button').html(i);
                i = i + ' *';
            }, 1000)
        },
        success: function (data) {
            clearInterval(int);
            $('.order-form .loader').fadeOut(500);
            $('.order-form .submit button').html($('.order-form .submit button').attr('data-text'));
            try{
                var result = $.parseJSON(data);
                var hide_summary = false, scroll_element = false;
                if(result['status'] == 'error'){
                    $.each(result, function (key, value) {
                        if(key != 'status' && key != 'general-error'){
                            $('.order-form [name="'+key+'"]').closest('.input-stdv').append('<span class="error">'+value+'</span>');
                            scroll_element = true;
                        }
                        else if(key == 'general-error'){
                            $('.general-error').html(value);
                            hide_summary = true;
                        }
                        if(key == 'register-date' || key == 'vehicle-value'){
                            hide_summary = true;
                            scroll_element = true;
                        }
                    });
                    if(hide_summary){
                        $('.order-form .order-summary:not(.with-change-plan)').slideUp(500);
                    }
                    else{
                        $('.order-form .order-summary:not(.with-change-plan)').slideDown(500);
                    }
                    if(scroll_element){
                        $('.input-stdv').each(function(){
                            if($(this).find('.error').length > 0){
                                $("html, body").animate({
                                    scrollTop: $(this).offset().top - 120
                                }, 1000);
                                return false;
                            }
                        })
                    }
                }
                else{
                    $('.order-form .order-summary:not(.with-change-plan)').slideDown(500);
                    $('.order-form').slideUp(500);
                    $('.order-form-view-mode').slideDown(500);
                    $('.step4-title').slideDown(500);
                    $('html, body').animate({
                        scrollTop: 0 // Ustaw wartość scrollTop na 0, aby przewinąć do góry strony
                    }, 0);

                }
            }
            catch(e){
                alert('Wystąpił jakiś błąd, spróbuj ponownie później.');
            }
        },
        error: function (errorThrown) {
            console.log(errorThrown);
        }
    });
}
function validate_wagas_inquiry(){
    $.ajax({
        url: ajax_obj.ajaxurl,
        method: 'post',
        data: {
            'action': 'validate_wagas_inquiry',
            'nonce': ajax_obj.nonce
        },
        beforeSend: function (errorThrown) {
            $('.inquiry').append('<div class="loader">'+$('.loader').html()+'</div>');
            $('.inquiry').addClass('loading');
        },
        success: function (data) {
            $('.inquiry').removeClass('loading');
            $('.inquiry .loader').remove();
            if(data == 'ok'){
                $('html, body').animate({
                    scrollTop: 0 // Ustaw wartość scrollTop na 0, aby przewinąć do góry strony
                }, 0);
                $('.inquiry').slideUp(500);
                $('.order-form').slideDown(500);
            }
        },
        error: function (errorThrown) {
            console.log(errorThrown);
        }
    });
}

function wagas_validate_single_field(key, value){
    $.ajax({
        url: ajax_obj.ajaxurl,
        method: 'post',
        data: {
            'action': 'wagas_validate_single_field',
            'key': key,
            'value': value,
            'data': $('.order-form form').serialize(),
            'nonce': ajax_obj.nonce
        },
        beforeSend: function () {
            $('[name="'+key+'"]').closest('.input-stdv').find('.error').remove();
            $('[name="'+key+'"]').closest('.input-stdv').find('label .input-loader').css('opacity', '1');
        },
        success: function (data) {
            console.log(data);
            $('[name="'+key+'"]').closest('.input-stdv').find('label .input-loader').css('opacity', '0');
            if(data != '-1'){
                $('.order-form [name="'+key+'"]').closest('.input-stdv').append('<span class="error">'+data+'</span>');
            }
        },
        error: function (errorThrown) {
            console.log(errorThrown);
        }
    });
}
function calculator_gb(){
    $.ajax({
        url: ajax_obj.ajaxurl,
        method: 'post',
        data: {
            'action': 'calculator_gb',
            'date' : $('.calculate-insurance [name="register-date"]').val(),
            'value' : $('.calculate-insurance [name="vehicle-value"]').val(),
            'nonce': ajax_obj.nonce
        },
        beforeSend: function (errorThrown) {
            $('.calculate-insurance .error').remove();
            $('.before-calculate').removeClass('active');
            $('.after-calculate').removeClass('active');
            $('.after-calculate-error').removeClass('active');
            $('.loader').addClass('active');
            $('.after-calculate .content .gap-block').remove();
            if($('.calc-content').length > 0){
                $('.calc-content > h2').slideUp(500);
            }
        },
        success: function (data) {
            $('.calculate-insurance').removeClass('locked');
            try{
                var result = $.parseJSON(data);
                if(result['result'] == 'error'){
                    $('.loader').removeClass('active');
                    $('.before-calculate').addClass('active');
                    // $('.after-calculate-error').addClass('active');
                    // $('.after-calculate-error').html(result['message']);
                    $('.calculate-insurance').append('<span class="error">'+result['message']+'</span>');
                }
                else{
                    var parts = $('.calculate-insurance [name="register-date"]').val().split('-');
                    var formattedDate = parts[2] + '-' + parts[1] + '-' + parts[0];

                    $('.after-calculate .form-data [data-input="register-date"] .value').html(formattedDate);
                    $('.after-calculate .form-data [data-input="vehicle-value"] .value').html($('.calculate-insurance [name="vehicle-value"]').val());
                    if($('.order-form').length > 0){
                        $('.order-form form input[name="register-date"]').val($('.calculate-insurance [name="register-date"]').val());
                        $('.order-form form input[name="vehicle-value"]').val($('.calculate-insurance [name="vehicle-value"]').val());
                    }
                    var popular = '';
                    $(result['plans']).each(function(i, val){
                        if(val['featured']){
                            popular = 'popular';
                        }
                        else{
                            popular = '';
                        }
                        $('.after-calculate .content').append('<div class="gap-block '+popular+'" data-period="'+val['period']+'">\n' +
                            '                            <div>\n' +
                            '                                <div class="period">\n' +
                            '                                    '+$('.after-calculate').attr('data-period')+' '+val['period']+' '+val['period-unit']+'\n' +
                            '                                </div>\n' +
                            '                                <div class="price">'+val['price']+' '+val['currency']+'</div>\n' +
                            '                                <div class="refund">'+$('.after-calculate').attr('data-refund')+' <br />'+val['refund']+' '+val['currency']+'</div>\n' +
                            '                                <div class="buy">\n' +
                            '                                    <a href="'+val['buy-url']+'">'+$('.after-calculate').attr('data-button')+'</a>\n' +
                            '                                </div>\n' +
                            '                                <div class="popular">'+$('.after-calculate').attr('data-popular')+'</div>\n' +
                            '                            </div>\n' +
                            '                        </div>');
                        $('.loader').removeClass('active');
                        $('.after-calculate').addClass('active');
                    })
                }
            }
            catch(e){
                alert('Wystąpił jakiś błąd, spróbuj ponownie później.');
            }
        },
        error: function (errorThrown) {
            console.log(errorThrown);
        }
    });
}